/**
 * orga-app-api - qschecks-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpContext 
        }       from '@angular/common/http';
import { Observable }                                        from 'rxjs';
import { OpenApiHttpParams, QueryParamStyle } from '../query.params';

// @ts-ignore
import { PrueflaufAufgabeAntwortRequest } from '../model/prueflaufAufgabeAntwortRequest';
// @ts-ignore
import { PrueflaufIdentifier } from '../model/prueflaufIdentifier';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class ControllingCommandService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * PostAufgabeKorrigieren
     * ORGA App Zugriff: * Mandant: ValidUser  Problem Types: * MandantIdFehlt: (MandantIdFehlt) * BenutzerNichtGefunden: (BenutzerNichtGefunden) * BenutzerNichtAktiviert: (BenutzerNichtAktiviert) * KeineLizenz: (KeineLizenz) * KeineLizenzOption: (KeineLizenzOption) * PrueflaufGeloescht: (QsChecksPrueflaufGeloescht) * PrueflaufNichtGefunden: (QsChecksPrueflaufNichtGefunden) * PruefplanNichtGefunden: (QsChecksPruefplanNichtGefunden) * KeinPrueflaufZugriff: (QsChecksKeinPrueflaufZugriff) * QsCheckModulNichtAktiv: (QsCheckModulNichtAktiv) 
     * @endpoint post /api/qs/command/controlling/v1/aufgabe/korrigieren
     * @param prueflaufAufgabeAntwortRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     * @param options additional options
     */
    public postAufgabeKorrigieren(prueflaufAufgabeAntwortRequest: PrueflaufAufgabeAntwortRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<PrueflaufIdentifier>;
    public postAufgabeKorrigieren(prueflaufAufgabeAntwortRequest: PrueflaufAufgabeAntwortRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<PrueflaufIdentifier>>;
    public postAufgabeKorrigieren(prueflaufAufgabeAntwortRequest: PrueflaufAufgabeAntwortRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<PrueflaufIdentifier>>;
    public postAufgabeKorrigieren(prueflaufAufgabeAntwortRequest: PrueflaufAufgabeAntwortRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (prueflaufAufgabeAntwortRequest === null || prueflaufAufgabeAntwortRequest === undefined) {
            throw new Error('Required parameter prueflaufAufgabeAntwortRequest was null or undefined when calling postAufgabeKorrigieren.');
        }

        let localVarHeaders = this.defaultHeaders;

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/api/qs/command/controlling/v1/aufgabe/korrigieren`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<PrueflaufIdentifier>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: prueflaufAufgabeAntwortRequest,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                ...(localVarTransferCache !== undefined ? { transferCache: localVarTransferCache } : {}),
                reportProgress: reportProgress
            }
        );
    }

}
